// Estado global via Preact signals.

import { signal, computed } from '@preact/signals';
import {
  getEndpoints,
  getActive,
  getUserId,
  getTheme,
  applyTheme,
  getShowSteps,
  getShowReasoning,
  type Endpoint,
  type ActiveRef,
} from '../lib/auth';

export const endpoints = signal<Endpoint[]>(getEndpoints());
export const active = signal<ActiveRef | null>(getActive());

export const activeEndpoint = computed<Endpoint | null>(() => {
  const a = active.value;
  if (!a) return null;
  return endpoints.value.find((e) => e.url === a.endpointUrl) ?? null;
});

export const activeToken = computed<string>(() => activeEndpoint.value?.token ?? '');
export const activeUrl = computed<string>(() => activeEndpoint.value?.url ?? '');
export const hasActiveTarget = computed<boolean>(() =>
  !!(active.value && activeEndpoint.value && activeToken.value),
);

export const userId = signal<string>(getUserId());
export const theme = signal<'light' | 'dark' | 'auto'>(getTheme());

export const showSteps = signal<boolean>(getShowSteps());
export const showReasoning = signal<boolean>(getShowReasoning());

// UI de shell: drawer da sidebar em mobile (< md). Em desktop a sidebar é
// sempre visível; o flag só governa o overlay em telas pequenas.
export const sidebarOpen = signal<boolean>(false);

applyTheme(theme.value);
const mql = window.matchMedia('(prefers-color-scheme: dark)');
mql.addEventListener('change', () => {
  if (theme.value === 'auto') applyTheme('auto');
});
